/**
 * A record's own detail screen, shown inside a side panel instead of as a page (owner 2026-10-31: a conversation opens
 * its strategies, backtests and artifacts inside it). The screens are the same components their routes render; inside
 * the panel they behave as part of the page around them:
 *
 *  - the title is a heading in the panel, never portaled into the shell header (`PageTitle`), where it would replace
 *    the page's own title;
 *  - no breadcrumbs and no back arrow (`PageHeader`, `PageTitle`): they lead out of the page the panel is on;
 *  - tabs keep their choice in component state (`useTabParam`), never in the URL the page around it owns.
 */
import { createContext, useContext } from 'react';

export const EntityPanelScopeContext = createContext(false);

/** True inside a side panel that shows a record's screen. */
export function useInEntityPanel(): boolean {
  return useContext(EntityPanelScopeContext);
}
